/**
 * @author Brendan Magee
 * @desc Component for creating a task from a story
 * @example <task-modal
 *              resolve="{ storyId, storyWebsite }"
 *              modalInstance="$uibModalInstance">
 *          </task-modal>
 */

const template = `<div class="height-75vh">
                    <iframe class="min-width-100 height-98"
                            id="external-iframe"
                            ng-if="$ctrl.src" 
                            ng-src="{{ $ctrl.src }}"
                            frameborder="0">
                    </iframe>
                    <div class="min-height-2 min-width-100 flexbox flex-justify-end pv1">
                      <button class="btn btn-primary"
                              ng-click="$ctrl.modalInstance.close()"
                              twp-translate>
                        CLOSE_V
                      </button>
                    </div>
                  </div>`;

class TaskModalv2Controller {
  constructor($sce, $translate, Task) {
    this.$sce = $sce;
    this.$translate = $translate;
    this.Task = Task;
  }

  $onInit() {
    let srcUrl = `/websked/1/iframe/taskCreate/${this.resolve.task.storyID}`;
    if (this.resolve.task.id) {
      srcUrl = `/websked/1/iframe/taskUpdate/${this.resolve.task.id}`;
    }
    this.src = this.$sce.trustAsResourceUrl(srcUrl);

    window.addEventListener(
      'message',
      (event) => {
        if (
          event.origin !==
          `${
            window.location.hostname.startsWith('localhost') ? 'http' : 'https'
          }://${window.location.hostname}`
        ) {
          return;
        }

        const task = new this.Task(event.data);
        this.modalInstance.close(task);
      },
      false
    );
  }
}

const arr = ['$sce', '$translate', 'Task', TaskModalv2Controller];

const taskModal = {
  template,
  controller: 'TaskModalv2Controller',
  bindings: {
    resolve: '<',
    modalInstance: '<'
  }
};

export default function (ngModule) {
  ngModule.component('taskModalv2', taskModal);
  ngModule.controller('TaskModalv2Controller', arr);
}
